(function(){
  "use strict";
  if (window.__cqInited) return; window.__cqInited = true;
  var ROOT = document;
  if (!ROOT) return;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var q = function(sel){ return ROOT.querySelector(sel); };
  var qa = function(sel){ return ROOT.querySelectorAll(sel); };

  var WHATSAPP = "";
  var DELIVERY_FEE = 3;

  /* toques rápidos: sem zoom de duplo toque nem seleção de texto nos botões; estado "a atualizar" */
  (function(){
    var st = document.createElement("style");
    st.textContent =
      '.cq-step,.cq-ci-qty button,[data-cq="checkout-btn"]{touch-action:manipulation;-webkit-tap-highlight-color:transparent;-webkit-user-select:none;user-select:none}'
      + '.cq-step-n,.cq-ci-qty span,[data-cq="cart-count"],[data-cq="cart-total"]{font-variant-numeric:tabular-nums}'
      + '[data-cq="sidecart"].cq-syncing [data-cq="cart-total"],.cq-cart-item.cq-pending .cq-ci-price{opacity:.55;transition:opacity .2s}'
      + '[data-cq="checkout-btn"].cq-busy{opacity:.7;pointer-events:none}';
    document.head.appendChild(st);
  })();

  /* nav scroll */
  var nav = q('[data-cq="nav"]');
  var onScroll = function(){ nav.classList.toggle("cq-scrolled", window.scrollY > 30); };
  onScroll();
  window.addEventListener("scroll", onScroll, { passive:true });

  /* scroll reveal */
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add("cq-in"); io.unobserve(e.target); } });
  }, { threshold:.16, rootMargin:"0px 0px -8% 0px" });
  qa(".cq-reveal,.cq-pop-in").forEach(function(el){ io.observe(el); });

  /* mostarda */
  var mustard = q('[data-cq="mustard-anim"]');
  if (mustard){
    var mio = new IntersectionObserver(function(ents){
      ents.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add("cq-in"); mio.unobserve(e.target); } });
    }, { threshold:0.66 });
    mio.observe(mustard);
  }

  /* drawer */
  var drawer = q('[data-cq="drawer"]');
  var overlay = q('[data-cq="overlay"]');
  var openDrawer = function(){ drawer.classList.add("cq-open"); overlay.classList.add("cq-show"); };
  var closeDrawer = function(){ drawer.classList.remove("cq-open"); overlay.classList.remove("cq-show"); };
  q('[data-cq="burger"]').addEventListener("click", openDrawer);
  q('[data-cq="drawer-close"]').addEventListener("click", closeDrawer);
  qa(".cq-dlink").forEach(function(a){ a.addEventListener("click", closeDrawer); });

  /* ===== Carrinho Shopify =====
     O ecrã mexe logo a cada clique (estado local "want"). O 1.º clique é enviado logo;
     os cliques feitos enquanto esse pedido está a caminho são juntados e enviados num só
     pedido /cart/update.js quando ele volta (nunca há dois pedidos ao mesmo tempo). A resposta do servidor nunca faz o número "voltar atrás": só substitui o
     valor local quando já não há cliques por enviar para essa variante.
     Quantidades contadas por VARIANTE (somando linhas), porque a promoção
     "Compra 5 leva 6" divide a mesma variante em duas linhas (pagas + oferta). */
  var sidecart = q('[data-cq="sidecart"]');
  var openCart = function(){ sidecart.classList.add("cq-open"); overlay.classList.add("cq-show"); };
  var closeCart = function(){ sidecart.classList.remove("cq-open"); overlay.classList.remove("cq-show"); };
  q('[data-cq="cart-icon"]').addEventListener("click", function(){ openCart(); if (!isBusy()) refreshCart(); });
  q('[data-cq="close-cart"]').addEventListener("click", closeCart);
  overlay.addEventListener("click", function(){ closeCart(); closeDrawer(); closeCheckout(); });

  var money = function(cents){ return (cents/100).toFixed(2).replace(".", ",") + "€"; };
  var UNITS_PER_PACK = (window.CQ_UNITS || 12);
  var MOLHO_IDS = (window.CQ_MOLHO_IDS || []).map(String);
  var isCart = function(c){ return c && Object.prototype.toString.call(c.items) === "[object Array]"; };
  var vId = function(it){ return String(it.variant_id != null ? it.variant_id : it.id); };
  var lineTotal = function(it){ return (it.final_line_price != null) ? it.final_line_price : (it.final_price || 0) * it.quantity; };

  var server = { items: [], item_count: 0, total_price: 0 };  // último carrinho confirmado pelo Shopify
  var serverQty = {};      // variante -> soma das linhas no servidor
  var want = {};           // variante -> quantidade escolhida e ainda não confirmada
  var inflight = null;     // pedido em curso (só um de cada vez)
  var flushQueued = false;
  var cartVersion = 0;     // sobe a cada alteração enviada; leituras antigas são ignoradas
  var waiters = [];
  var totals = { count: 0, total: 0 };

  var toastEl = q('[data-cq="toast"]'); var toastTimer = null;
  function toast(msg){
    if (!toastEl || !msg) return;
    toastEl.textContent = msg;
    toastEl.classList.add("cq-show");
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ toastEl.classList.remove("cq-show"); }, 2800);
  }
  function errMsg(res){ return (res.data && (res.data.description || res.data.message)) || "Sem stock disponível de momento."; }
  function setText(el, t){ if (el && el.textContent !== t) el.textContent = t; }

  function postJSON(url, body){
    return fetch(url, {
      method:"POST", headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify(body)
    }).then(function(r){
      return r.json().then(function(d){ return { ok:r.ok, status:r.status, data:d }; },
                           function(){ return { ok:r.ok, status:r.status, data:null }; });
    }).catch(function(){ return { ok:false, status:0, data:null }; });
  }

  function setServer(c){
    server = c; serverQty = {};
    (c.items || []).forEach(function(it){ var v = vId(it); serverQty[v] = (serverQty[v] || 0) + it.quantity; });
  }
  function qtyOf(id){ id = String(id); return Object.prototype.hasOwnProperty.call(want, id) ? want[id] : (serverQty[id] || 0); }
  function isDirty(){ return Object.keys(want).length > 0; }
  function isBusy(){ return isDirty() || !!inflight || flushQueued; }
  function linesOf(id){ return (server.items || []).filter(function(it){ return vId(it) === id; }); }

  function parsePrice(t){
    var m = String(t || "").match(/(\d{1,3}(?:[.\s]\d{3})*|\d+)[,.](\d{2})/);
    return m ? parseInt(m[1].replace(/\D/g, ""), 10) * 100 + parseInt(m[2], 10) : 0;
  }
  /* nome / preço unitário de uma variante: do carrinho, ou do próprio menu se ainda não lá está */
  function metaOf(id, lines){
    if (lines.length){
      var l = lines[0];
      return { title: l.product_title, price: (l.original_price != null ? l.original_price : (l.price || 0)), molho: MOLHO_IDS.indexOf(String(l.product_id)) > -1 };
    }
    var m = { title: "", price: 0, molho: false };
    var btn = q('[data-cq="step"][data-variant-id="' + id + '"]');
    var box = btn && (btn.closest(".cq-prod") || btn.closest(".cq-molho"));
    if (box){
      var nm = box.querySelector(".cq-prod-name, .cq-molho-name");
      var pr = box.querySelector(".cq-prod-price, .cq-molho-price");
      m.title = nm ? nm.textContent.trim() : "";
      m.price = parsePrice(pr ? pr.textContent : "");
      m.molho = box.classList.contains("cq-molho");
    }
    return m;
  }

  /* linhas a mostrar (uma por variante) + totais, com o estado local por cima do servidor */
  function view(){
    var order = [], seen = {};
    Object.keys(want).forEach(function(v){ if (!serverQty[v]){ seen[v] = 1; order.push(v); } });  // novos aparecem no topo, como no Shopify
    (server.items || []).forEach(function(it){ var v = vId(it); if (!seen[v]){ seen[v] = 1; order.push(v); } });
    var out = [], count = 0, total = server.total_price || 0;
    order.forEach(function(v){
      var n = qtyOf(v), sq = serverQty[v] || 0, lines = linesOf(v), meta = metaOf(v, lines);
      var sTot = 0, free = 0;
      lines.forEach(function(it){ var lt = lineTotal(it); sTot += lt; if (lt === 0 && (it.original_line_price || 0) > 0) free += it.quantity; });
      var exact = (n === sq);
      var est = exact ? sTot : Math.max(0, sTot + (n - sq) * meta.price);   // estimativa até o Shopify confirmar
      total += est - sTot;
      count += n;
      if (n > 0) out.push({ id: v, qty: n, title: meta.title, total: est, free: exact ? free : 0, molho: meta.molho, exact: exact });
    });
    return { lines: out, count: count, total: Math.max(0, total) };
  }

  function parseTiers(str){
    if (!str) return [];
    return str.split(';').map(function(s){
      var parts = s.split(':');
      if (parts.length < 2) return null;
      var u = parseInt((parts[0]||'').replace(/[^0-9]/g,''), 10);
      var p = parseFloat((parts[1]||'').replace(',', '.').replace(/[^0-9.]/g,''));
      if (!u || isNaN(p)) return null;
      return { minUnits: u, unitPrice: Math.round(p * 100) };
    }).filter(function(t){ return t; }).sort(function(a,b){ return a.minUnits - b.minUnits; });
  }
  function updateSave(id){
    var prodEl = q('[data-cq="prod"][data-variant-id="'+id+'"]');
    var saveEl = q('[data-cq="save"][data-variant-id="'+id+'"]');
    if (!prodEl || !saveEl) return;
    var units = parseInt(prodEl.getAttribute('data-units'),10) || 1;
    var baseUnit = parseInt(prodEl.getAttribute('data-unit-price'),10) || 0;
    var tiers = parseTiers(prodEl.getAttribute('data-tiers'));
    var packs = qtyOf(id);
    var totalUnits = packs * units;
    var applied = null;
    for (var i=0;i<tiers.length;i++){ if (totalUnits >= tiers[i].minUnits) applied = tiers[i]; }
    if (applied && baseUnit > 0 && applied.unitPrice < baseUnit){
      var saved = (baseUnit - applied.unitPrice) * totalUnits;
      saveEl.textContent = 'Estás a poupar ' + money(saved);
      saveEl.removeAttribute('hidden');
    } else {
      saveEl.setAttribute('hidden','');
      saveEl.textContent = '';
    }
  }
  function paintSteppers(){
    qa('[data-qty-for]').forEach(function(el){
      var id = el.getAttribute('data-qty-for');
      var n = qtyOf(id);
      var units = parseInt(el.getAttribute('data-units'),10) || 1;
      setText(el, String(n * units));
      el.classList.toggle('cq-active', n > 0);
      updateSave(id);
    });
  }

  /* carrinho lateral: as linhas são atualizadas no sítio (não se recria o HTML a cada clique,
     para o botão não desaparecer debaixo do dedo) */
  var itemsBox = q('[data-cq="cart-items"]');
  var EMPTY_HTML = '<p class="cq-cart-empty">O carrinho está vazio.<br>Escolhe uns croquetes 😋</p>';
  function rowPriceText(l){
    var units = l.molho ? "" : (UNITS_PER_PACK ? (l.qty * UNITS_PER_PACK) + " unidades · " : "");
    var free = l.free ? " (" + l.free + (l.free > 1 ? " ofertas)" : " oferta)") : "";
    return units + money(l.total) + free;
  }
  function paintDrawer(lines){
    if (!lines.length){ if (!itemsBox.querySelector(".cq-cart-empty")) itemsBox.innerHTML = EMPTY_HTML; return; }
    var empty = itemsBox.querySelector(".cq-cart-empty"); if (empty) empty.parentNode.removeChild(empty);
    var existing = {};
    Array.prototype.forEach.call(itemsBox.children, function(r){
      var k = r.getAttribute && r.getAttribute("data-vid");
      if (k) existing[k] = r; else r.parentNode && r.parentNode.removeChild(r);
    });
    var prev = null;
    lines.forEach(function(l){
      var row = existing[l.id];
      if (!row){
        row = document.createElement("div");
        row.className = "cq-cart-item";
        row.setAttribute("data-vid", l.id);
        row.innerHTML = '<div class="cq-ci-info"><div class="cq-ci-name"></div><div class="cq-ci-price"></div></div>'
          + '<div class="cq-ci-qty"><button type="button" data-act="dec" aria-label="Menos">−</button><span class="cq-ci-n"></span><button type="button" data-act="inc" aria-label="Mais">+</button></div>';
      }
      delete existing[l.id];
      var ref = prev ? prev.nextSibling : itemsBox.firstChild;
      if (row !== ref) itemsBox.insertBefore(row, ref);
      setText(row.querySelector(".cq-ci-name"), l.title);
      setText(row.querySelector(".cq-ci-price"), rowPriceText(l));
      setText(row.querySelector(".cq-ci-n"), String(l.qty));
      row.classList.toggle("cq-pending", !l.exact);
      prev = row;
    });
    Object.keys(existing).forEach(function(k){ var r = existing[k]; r.parentNode && r.parentNode.removeChild(r); });
  }
  itemsBox.addEventListener("click", function(e){
    var b = e.target.closest && e.target.closest("button[data-act]");
    if (!b || !itemsBox.contains(b)) return;
    var row = b.closest("[data-vid]");
    if (!row) return;
    change(row.getAttribute("data-vid"), b.getAttribute("data-act") === "inc" ? 1 : -1);
  });

  function render(){
    var v = view();
    totals.count = v.count; totals.total = v.total;
    paintDrawer(v.lines);
    setText(q('[data-cq="cart-total"]'), money(v.total));
    setText(q('[data-cq="cart-count"]'), String(v.count));
    paintSteppers();
  }
  function setSyncing(on){ if (sidecart) sidecart.classList.toggle("cq-syncing", !!on); }
  function settle(){ if (isBusy()) return; setSyncing(false); var w = waiters; waiters = []; w.forEach(function(f){ f(); }); }

  /* clique em + / − : o ecrã muda já; o envio fica agendado */
  function change(id, delta){
    id = String(id);
    var cur = qtyOf(id), n = Math.max(0, cur + delta);
    if (n === cur) return;
    want[id] = n;
    render();
    setSyncing(true);
    schedule();
  }
  /* junta os cliques do mesmo instante; se já houver um pedido a caminho, espera por ele */
  function schedule(){
    if (flushQueued) return;
    flushQueued = true;
    Promise.resolve().then(function(){ flushQueued = false; flush(); });
  }

  /* monta o pedido: para cada variante, a 1.ª linha fica com o total e as outras a 0 */
  function buildUpdates(){
    var updates = {}, sent = {}, any = false;
    Object.keys(want).forEach(function(id){
      var target = want[id];
      if (target === (serverQty[id] || 0)){ delete want[id]; return; }
      sent[id] = target; any = true;
      var first = true;
      (server.items || []).forEach(function(it){
        if (vId(it) !== id) return;
        updates[it.key] = first ? target : 0; first = false;
      });
      if (first) updates[id] = target;   // ainda não está no carrinho → entra pelo id da variante
    });
    return { updates: updates, sent: sent, any: any };
  }

  function flush(){
    if (inflight) return;                        // volta a correr quando o pedido atual acabar
    var b = buildUpdates();
    if (!b.any){ render(); settle(); return; }
    cartVersion++;
    setSyncing(true);
    inflight = postJSON("/cart/update.js", { updates: b.updates }).then(function(res){
      inflight = null;
      if (res.ok && isCart(res.data)){
        setServer(res.data);
        var short = false;
        Object.keys(b.sent).forEach(function(id){
          if (want[id] === b.sent[id]){
            delete want[id];
            if ((serverQty[id] || 0) < b.sent[id]) short = true;
          }
        });
        if (short) toast("Quantidade ajustada ao stock disponível.");
      } else {
        Object.keys(b.sent).forEach(function(id){ if (want[id] === b.sent[id]) delete want[id]; });
        toast(errMsg(res));
        return refreshCart(true);
      }
    }).then(function(){
      render();
      if (isDirty()) flush(); else settle();
    });
  }

  /* espera que todos os cliques estejam gravados no Shopify (máx. 10 s) */
  function whenSynced(){
    if (!isBusy()) return Promise.resolve();
    return new Promise(function(resolve){
      var done = false, fin = function(){ if (!done){ done = true; resolve(); } };
      waiters.push(fin);
      setTimeout(fin, 10000);
      if (!inflight) flush();
    });
  }

  function refreshCart(force){
    var v = cartVersion;
    return fetch("/cart.js", { headers:{ "Accept":"application/json" }, cache:"no-store" })
      .then(function(r){ return r.json(); })
      .then(function(c){
        if (!isCart(c)) return;
        if (!force && (v !== cartVersion || inflight)) return;   // leitura antiga — ignorar
        setServer(c); render();
      })
      .catch(function(){});
  }

  /* steppers do menu e molhos */
  qa('[data-cq="step"]').forEach(function(btn){
    btn.addEventListener("click", function(){
      if (btn.disabled) return;
      change(btn.getAttribute("data-variant-id"), btn.getAttribute("data-act") === "inc" ? 1 : -1);
    });
  });

  /* "Finalizar": se ainda houver cliques por gravar, espera por eles antes de seguir */
  var passCheckout = false;
  window.addEventListener("click", function(e){
    if (passCheckout) return;
    var btn = e.target.closest && e.target.closest('[data-cq="checkout-btn"]');
    if (!btn) return;
    if (btn.classList.contains("cq-busy")){ e.preventDefault(); e.stopImmediatePropagation(); return; }
    if (!isBusy()){
      if (totals.count === 0){ e.preventDefault(); e.stopImmediatePropagation(); toast("Adiciona uns croquetes ao carrinho primeiro!"); }
      return;
    }
    e.preventDefault(); e.stopImmediatePropagation();
    var html = btn.innerHTML;
    btn.classList.add("cq-busy"); btn.textContent = "A atualizar o carrinho…";
    whenSynced().then(function(){
      btn.innerHTML = html; btn.classList.remove("cq-busy");
      if (totals.count === 0){ toast("Adiciona uns croquetes ao carrinho primeiro!"); return; }
      passCheckout = true; try { btn.click(); } finally { passCheckout = false; }
    });
  }, true);

  /* se a página for fechada com cliques por gravar, envia-os na mesma */
  window.addEventListener("pagehide", function(){
    if (!isDirty() || inflight) return;
    var b = buildUpdates();
    if (!b.any) return;
    try {
      fetch("/cart/update.js", { method:"POST", keepalive:true, headers:{ "Content-Type":"application/json", "Accept":"application/json" }, body: JSON.stringify({ updates: b.updates }) });
    } catch(err){}
  });
  /* ao voltar à página (botão "voltar" do checkout, outro separador) relê o carrinho */
  window.addEventListener("pageshow", function(e){ if (e.persisted && !isBusy()) refreshCart(true); });
  document.addEventListener("visibilitychange", function(){ if (document.visibilityState === "visible" && !isBusy()) refreshCart(); });

  window.__cqCart = { whenSynced: whenSynced, qty: qtyOf, busy: isBusy };

  /* tabs Feitos na hora / Congelados */
  var tabEls = qa('[data-cq="tab"]');
  var panelEls = qa('[data-cq="panel"]');
  var pill = q('[data-cq="tab-pill"]');
  function movePill(t){ if (pill && t){ pill.style.width = t.offsetWidth + "px"; pill.style.transform = "translateX(" + t.offsetLeft + "px)"; } }
  tabEls.forEach(function(t){
    t.addEventListener("click", function(){
      var name = t.dataset.tab;
      tabEls.forEach(function(x){ var on = x === t; x.classList.toggle("cq-tab-on", on); x.setAttribute("aria-selected", on ? "true" : "false"); });
      panelEls.forEach(function(p){ p.classList.toggle("cq-tab-on", p.dataset.panel === name); });
      movePill(t);
    });
  });
  var activeTab = q('[data-cq="tab"].cq-tab-on') || tabEls[0];
  if (activeTab){ requestAnimationFrame(function(){ movePill(activeTab); }); }
  window.addEventListener("resize", function(){ var a = q('[data-cq="tab"].cq-tab-on'); if (a) movePill(a); }, { passive:true });

  refreshCart(true);

  /* ===== Entrega / Recolha + checkout Shopify ===== */
  var checkout = q('[data-cq="checkout"]');
  var coDays = q('[data-cq="co-days"]');
  var coTimes = q('[data-cq="co-times"]');
  var coSummary = q('[data-cq="co-summary"]');
  var coConfirm = q('[data-cq="co-confirm"]');
  var coMethodBtns = qa('[data-cq="co-method"]');
  var pickupInfo = q('[data-cq="pickup-info"]');
  var CONFIRM_LABEL = (coConfirm.textContent || "Continuar para o checkout →").trim();
  var pickupAddrEl = q('[data-cq="pickup-addr"]');
  var freshNotice = q('[data-cq="fresh-notice"]');
  var timeBlock = q('[data-cq="time-block"]');
  var delivNote = q('[data-cq="delivery-window-note"]');
  var dayLabel = q('[data-cq="day-label"]');
  var timeLabel = q('[data-cq="time-label"]');
  var method = "delivery";
  var DELIVERY_DOWS = [1, 3, 5];   // Seg, Qua, Sex — únicos dias de entrega em casa
  var SAME_DAY_CUTOFF_HOUR = 12;   // encomenda para o próprio dia só até às 12h

  /* "Feitos na hora" = só recolha. Se houver algum no carrinho, força recolha. */
  var FRESH_IDS = (window.CQ_FRESH_IDS || []).map(String);
  function cartHasFresh(){
    return FRESH_IDS.some(function(id){ return qtyOf(id) > 0; });
  }
  var WD = ["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"];
  var MO = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];
  /* Recolha: slots de 15 min gerados entre o horário mais cedo e mais tarde de CQ_TIMES */
  function pad2(n){ return (n < 10 ? "0" : "") + n; }
  function hmLabel(mins){ return pad2(Math.floor(mins/60)) + "h" + pad2(mins % 60); }
  function buildPickupSlots(){
    var raw = (window.CQ_TIMES && window.CQ_TIMES.length) ? window.CQ_TIMES : ["19:00","21:30"];
    var mins = raw.map(function(s){ var p = String(s).split(":"); return parseInt(p[0],10)*60 + parseInt(p[1]||0,10); }).filter(function(n){ return !isNaN(n); });
    if (!mins.length) return [];
    var start = Math.min.apply(null, mins), end = Math.max.apply(null, mins);
    var slots = [];
    for (var m = start; m + 15 <= end; m += 15){ slots.push(hmLabel(m) + " - " + hmLabel(m + 15)); }
    return slots;
  }
  var selDay = null, selTime = null;

  var openCheckout = function(){ checkout.classList.add("cq-open"); overlay.classList.add("cq-show"); };
  var closeCheckout = function(){ checkout.classList.remove("cq-open"); overlay.classList.remove("cq-show"); };

  function setMethod(m){
    if (m === "delivery" && cartHasFresh()){ m = "pickup"; }   // feitos na hora nunca entregam
    method = m;
    coMethodBtns.forEach(function(b){ b.classList.toggle("cq-sel", b.getAttribute("data-method") === m); });
    var isPickup = (m === "pickup");
    if (pickupInfo) pickupInfo.style.display = isPickup ? "block" : "none";
    if (dayLabel) dayLabel.textContent = isPickup ? "Dia de recolha" : "Dia de entrega";
    if (timeLabel) timeLabel.textContent = "Hora de recolha";
    if (timeBlock) timeBlock.style.display = isPickup ? "block" : "none";   // hora só na recolha
    if (delivNote) delivNote.style.display = isPickup ? "none" : "block";   // aviso da janela de entrega só na entrega
    renderSchedule(); renderSummary(); validate();
  }
  coMethodBtns.forEach(function(b){ b.addEventListener("click", function(){ if (b.disabled) return; setMethod(b.getAttribute("data-method")); }); });

  /* Bloqueia a entrega e mostra o aviso quando há feitos na hora no carrinho */
  function updateFreshLock(){
    var locked = cartHasFresh();
    if (freshNotice) freshNotice.style.display = locked ? "block" : "none";
    coMethodBtns.forEach(function(b){
      if (b.getAttribute("data-method") === "delivery"){
        b.disabled = locked;
        b.classList.toggle("cq-disabled", locked);
      }
    });
    if (locked){ setMethod("pickup"); }
    return locked;
  }

  /* Entrega: só Seg/Qua/Sex; hoje só até às 12h. Recolha: amanhã em diante, sem domingos. */
  function buildDays(){
    var out = [];
    var today = new Date(); today.setHours(0,0,0,0);
    var now = new Date();
    if (method === "delivery"){
      for (var i = 0; i < 21 && out.length < 8; i++){
        var c = new Date(today); c.setDate(today.getDate() + i);
        if (DELIVERY_DOWS.indexOf(c.getDay()) === -1) continue;                 // só Seg/Qua/Sex
        if (i === 0 && now.getHours() >= SAME_DAY_CUTOFF_HOUR) continue;        // hoje já passou o limite das 12h
        out.push(c);
      }
      return out;
    }
    var d = new Date(today); d.setDate(d.getDate() + 1);
    while (out.length < 10){ if (d.getDay() !== 0) out.push(new Date(d)); d.setDate(d.getDate() + 1); }
    return out;
  }
  function renderSchedule(){
    selDay = null; selTime = null;
    var days = buildDays();
    coDays.innerHTML = days.length ? days.map(function(dt){
      var label = WD[dt.getDay()] + ", " + dt.getDate() + " " + MO[dt.getMonth()];
      return '<button type="button" class="cq-co-day" data-label="'+label+'"><span class="cq-wd">'+WD[dt.getDay()]+'</span><span class="cq-dn">'+dt.getDate()+'</span><span class="cq-mo">'+MO[dt.getMonth()]+'</span></button>';
    }).join("") : '<p class="cq-co-empty">Sem dias disponíveis de momento.</p>';
    coDays.querySelectorAll(".cq-co-day").forEach(function(b){
      b.addEventListener("click", function(){
        var wasSel = b.classList.contains("cq-sel");
        coDays.querySelectorAll(".cq-co-day").forEach(function(x){ x.classList.remove("cq-sel"); });
        if (wasSel){ selDay = null; } else { b.classList.add("cq-sel"); selDay = b.dataset.label; }
        validate();
      });
    });
    if (method === "pickup"){
      coTimes.innerHTML = buildPickupSlots().map(function(t){ return '<button type="button" class="cq-co-time">'+t+'</button>'; }).join("");
      coTimes.querySelectorAll(".cq-co-time").forEach(function(b){
        b.addEventListener("click", function(){
          var wasSel = b.classList.contains("cq-sel");
          coTimes.querySelectorAll(".cq-co-time").forEach(function(x){ x.classList.remove("cq-sel"); });
          if (wasSel){ selTime = null; } else { b.classList.add("cq-sel"); selTime = b.textContent; }
        });
      });
    } else {
      coTimes.innerHTML = "";
    }
  }
  function renderSummary(){
    var tail = (method === "pickup") ? "" : " + portes";
    coSummary.innerHTML =
      '<div class="cq-co-sr"><span>Subtotal ('+totals.count+' art.)</span><span>'+money(totals.total)+'</span></div>'
      + '<div class="cq-co-sr cq-tot"><span>A pagar no checkout</span><span>'+money(totals.total)+tail+'</span></div>';
  }

  function validate(){
    var ok = !!selDay;                                   // basta escolher um dia
    coConfirm.disabled = !ok;
    coConfirm.textContent = ok ? CONFIRM_LABEL : "Escolhe um dia primeiro";
    return ok;
  }
  setMethod("delivery");

  q('[data-cq="checkout-btn"]').addEventListener("click", function(){
    if (totals.count === 0){ alert("Adiciona uns croquetes ao carrinho primeiro!"); return; }
    var locked = updateFreshLock();          // recolha forçada se houver feitos na hora (já renderiza)
    if (!locked){ setMethod("delivery"); }   // caso contrário, entrega por defeito (já renderiza)
    renderSummary(); validate();
    closeCart(); openCheckout();
  });
  q('[data-cq="checkout-close"]').addEventListener("click", closeCheckout);

  coConfirm.addEventListener("click", function(){
    if (totals.count === 0){ closeCheckout(); return; }
    if (!selDay){ validate(); if (coDays) coDays.scrollIntoView({ behavior:"smooth", block:"center" }); return; }
    coConfirm.disabled = true; coConfirm.textContent = "A abrir checkout…";

    var isPickup = (method === "pickup");
    var methodLabel = isPickup ? "Recolha" : "Entrega em casa";
    var pickupAddr = pickupAddrEl ? pickupAddrEl.textContent.trim() : "";
    var whenWord = isPickup ? "Recolha" : "Entrega";
    var noteLines = ["— PREFERÊNCIA CROQUÊ —", "Método: " + methodLabel];
    if (isPickup){ noteLines.push("Local de recolha: " + pickupAddr); }
    noteLines.push(whenWord + " preferida: " + selDay + (selTime ? " às " + selTime : (isPickup ? "" : " (entre 19h e 21h30)")));
    var note = noteLines.join("\n");

    var payload = {
      note: note,
      attributes: {
        "Método": methodLabel,
        "Local de recolha": isPickup ? pickupAddr : "",
        "Dia": selDay || "",
        "Hora": selTime || ""
      }
    };
    whenSynced().then(function(){
      return fetch("/cart/update.js", {
        method:"POST", headers:{ "Content-Type":"application/json", "Accept":"application/json" },
        body: JSON.stringify(payload)
      });
    }).then(function(){ window.location.href = "/checkout"; })
      .catch(function(){ window.location.href = "/checkout"; });
  });

  /* croquete crossfade — começa SEMPRE fechado; só abre/fecha ao clicar (ou Enter/Espaço) */
  var stage = q('[data-cq="stage"]');
  var hint = q('[data-cq="hint"]');
  if (stage){
    var toggleStage = function(){
      var open = stage.classList.toggle("cq-open");
      if (hint) hint.style.opacity = open ? ".25" : ".85";
    };
    stage.addEventListener("click", toggleStage);
    stage.addEventListener("keydown", function(e){ if (e.key === "Enter" || e.key === " "){ e.preventDefault(); toggleStage(); } });
  }

  /* parallax hero */
  if (!reduce && window.matchMedia("(hover:hover)").matches){
    var hc = q('[data-cq="hero-croq"]');
    if (hc){
      window.addEventListener("mousemove", function(e){
        if (getComputedStyle(hc).display === "none") return;
        var px = (e.clientX / window.innerWidth - .5);
        var py = (e.clientY / window.innerHeight - .5);
        hc.style.transform = "translate(" + (px*18) + "px, " + (py*14) + "px)";
      }, { passive:true });
    }
  }

  /* bolinhas parallax */
  if (!reduce){
    var bolas = Array.prototype.slice.call(qa(".cq-bolinha[data-par]"));
    var bt = null;
    var moveBolas = function(){
      var vh = window.innerHeight || document.documentElement.clientHeight;
      bolas.forEach(function(b){
        var k = parseFloat(b.dataset.par) || .4;
        var r = b.parentElement.getBoundingClientRect();
        var center = (r.top + r.height/2) - vh/2;
        var par = -center * k * 0.06;
        if (par > 40) par = 40; else if (par < -40) par = -40;
        b.style.setProperty("--par", par.toFixed(1) + "px");
      });
      bt = null;
    };
    window.addEventListener("scroll", function(){ if (!bt) bt = requestAnimationFrame(moveBolas); }, { passive:true });
    window.addEventListener("resize", function(){ if (!bt) bt = requestAnimationFrame(moveBolas); }, { passive:true });
    moveBolas();
  }
})();
